import { createApp, h } from "vue";
import Index from "./index.vue";
import account from "./plugins/account";
import arms from "./plugins/arms.ts";
import bridge from "./plugins/bridge";
import direct from "./plugins/direct";
import message from "./plugins/message";
import router from "./plugins/router";
import utils from "./plugins/utils";
import wechat from "./plugins/wechat";

const app = createApp({
  data() {
    return {
      vConsole: null,
    };
  },
  render() {
    return h(Index);
  },
  async created() {
    if (import.meta.env.DEV) return;
    if (import.meta.env.VITE_SDK_MODE === "prd") return;
    const vconsole = await import("vconsole");
    this.vConsole = new vconsole.default();
  },
});

app.use(router);
app.use(account);
app.use(direct);
app.use(message);
app.use(utils);
app.use(arms);
app.use(wechat);
app.use(bridge);
app.mount("#app");
